import { gql, TypedDocumentNode } from '@common/hooks';
import {
  LoadBalancingWorkerQueryCgResponse,
  LoadBalancingWorkerQueryVariables,
} from '@common/graphql';

export type LoadBalancingWorkerType = NonNullable<
  LoadBalancingWorkerQueryCgResponse['loadBalancingWorker']
>;

export type LoadBalancingWorkerTermType =
  LoadBalancingWorkerType['terms'][number];

// Single worker (+ full term history) for the Team Review worker drawer, authorized by
// home unit. `schedulingPeriodId` is optional and only drives `fteHours` — absent ⇒ null.
export const LOAD_BALANCING_WORKER_QUERY: TypedDocumentNode<
  LoadBalancingWorkerQueryCgResponse,
  LoadBalancingWorkerQueryVariables
> = gql`
  query LoadBalancingWorker($id: ID!, $schedulingPeriodId: ID) {
    loadBalancingWorker(id: $id, schedulingPeriodId: $schedulingPeriodId) {
      id
      name
      terms {
        id
        active
        effectiveStartDate
        effectiveEndDate
        employmentType
        role
        homeUnit
        fteHours
        ftePercentage
        preferredTime
        shiftPatternPreference
        chargeEligible
      }
    }
  }
`;
